import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';
import { Client, ExternalTokenDataIn, ExternalTokenDataInType, RemoteTokenDataIn } from '../../../../api/api-reference';

@Component({
  selector: 'app-sequential-token-load-setup',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, RouterLink, AngularSvgIconModule],
  templateUrl: './sequential-token-load-setup.component.html',
  styleUrl: './sequential-token-load-setup.component.scss'
})
export class SequentialTokenLoadSetupComponent {
  model = new SequentialTokenLoad();

  tokenTypes = Object.values(ExternalTokenDataInType);

  constructor(
    private client: Client,
    private toastr: ToastrService,
    private router: Router,
  ) {}

  formatTypeLabel(type: string): string {
    return type.replace(/(?<=[a-z])(?=[A-Z])/g, ' ');
  }

  get canAddToken(): boolean {
    const last = this.model.tokens[this.model.tokens.length - 1];
    return last.type !== '' && last.value !== '';
  }

  formatTokenWithDashes(token: string): string {
    const cleaned = token.replace(/[\s-]/g, '');
    if (!/^\d{20}$/.test(cleaned)) {
      throw new Error("Token must be exactly 20 digits.");
    }
    return cleaned.replace(/(\d{4})(?=\d)/g, '$1-');
  }

  addToken() {
    if (!this.canAddToken) return;
    this.model.tokens.push(new Token());
  }

  removeToken(index: number) {
    this.model.tokens.splice(index, 1);
  }

  onSubmit() {
    const body = new RemoteTokenDataIn({
      meterNumber: this.model.meterNumber,
      tokens: this.model.tokens.map((t, i) => {
        const token = new ExternalTokenDataIn();
        token.type = t.type as ExternalTokenDataInType;
        token.value = this.formatTokenWithDashes(t.value);
        return token;
      }),
    });

    this.client.executeTokensSequentially(body).subscribe({
      next: () => {
        this.toastr.success('Successfully saved.');
        this.router.navigate(['/remote-command/sequential-token-load']);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}

export class Token {
  type: ExternalTokenDataInType | '' = '';
  value: string = '';
}

export class SequentialTokenLoad {
  meterNumber: string = '';
  tokens: Token[] = [new Token()];
}
